<template>
  <a-modal
    class="users-in-active-strategies__modal"
    :visible="visible"
    :bodyStyle="{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '36px',
    }"
    @cancel="handleClose"
  >
    <ExclamationCircleOutlined style="color: #faad14; font-size: 52px; display: block" />

    <div class="info">
      <h5 class="info info__title">
        Esta estrategia cuenta con usuarios asignados a otra estrategia actualmente activa
      </h5>

      <p class="info info__description">
        Para poder lanzar esta estrategia, estos usuarios deben pertenecer solo a una estrategia
        activa.
      </p>
    </div>

    <a-table
      size="middle"
      :dataSource="data"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: 215 }"
    />

    <a-button type="primary" class="modal__button" @click="handleClose">Aceptar</a-button>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

const columns = [
  {
    title: "Usuario",
    key: "user.fullname",
    dataIndex: ["user", "fullname"],
    ellipsis: true,
  },
  {
    title: "Estrategia activa",
    key: "strategy",
    dataIndex: "strategy",
    ellipsis: true,
  },
];

export default defineComponent({
  components: {
    ExclamationCircleOutlined,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    data: {
      required: true,
      type: Array,
    },
  },
  setup(props, { emit }) {
    const handleClose = () => {
      emit("close");
    };

    return {
      handleClose,
      columns,
    };
  },
});
</script>

<style lang="sass" scoped>
:deep(.ant-modal-header)
  display: none

.info
  color: $gray-13
  margin: 0
  text-align: center

  &__title
    font-size: 16px
    font-weight: 600
    margin: 15px 0 12px

  &__description
    font-size: 14px
    margin-bottom: 20px

.modal__button
  width: 100%
  margin-top: 20px
</style>

<style>
.users-in-active-strategies__modal .ant-modal-footer {
  display: none !important;
}

.users-in-active-strategies__modal
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background-color: #feffe6;
}
</style>
